module.exports = __webpack_public_path__ + "img/xuanzhuan.8005cbcd.png";